import {type CreatePaymentMethodKlarnaData} from '@stripe/stripe-js';
import {type StripeGateway, type IStripeContext} from '../../../models/stripe';
import {PeachPayCustomer} from '../../../reducers/peachPayCustomerReducer';
import {getLocaleText} from '../../../util/translation';
import klarnaBadgeURL from '../../../../img/badge/klarna.svg';
import klarnaImageURL from '../../../../img/marks/klarna.svg';
import {Feature} from '../../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../../@type/features';

function initStripeKlarnaMethod(): StripeGateway {
	return {
		config: {
			name: Feature.metadata<string>(FeatureFlag.STRIPE_KLARNA_GATEWAY, 'title') ?? 'Klarna',
			gatewayId: 'peachpay_stripe_klarna',
			description: getLocaleText('After selecting pay you will be redirected to complete your payment.'),
			assets: {
				title: {src: klarnaImageURL},
				badge: {src: klarnaBadgeURL},
			},
		},
		async tokenize(context) {
			const {stripe} = context;

			const {paymentMethod, error} = await stripe.createPaymentMethod({
				type: 'klarna',
				billing_details: PeachPayCustomer.stripeBillingDetails(),
			} as CreatePaymentMethodKlarnaData);

			if (error) {
				const message = error.message ?? 'Failed to tokenize payment method.';

				return [null, {
					paymentStatus: 'creationfailed',
					note: message,
				}];
			}

			if (!paymentMethod?.id) {
				return [null, {
					paymentStatus: 'creationfailed',
					note: 'Failed to tokenize payment method.',
				}];
			}

			return [paymentMethod.id, {}];
		},
		async confirm(context: IStripeContext, clientSecret: string, intermediateURL: string) {
			const {stripe} = context;

			const {paymentIntent, error} = await stripe.confirmKlarnaPayment(clientSecret, {return_url: intermediateURL});

			if (error) {
				const message = error.message ?? 'Failed to confirm payment.';
				return [null, {
					note: message,
				}];
			}

			if (paymentIntent) {
				return ['success', {}];
			}

			return [null, {}];
		},
	};
}

export {initStripeKlarnaMethod};
